import styled from 'styled-components';

export const SectionWrapper = styled.div<{ $inPreview: boolean; theme: any; $backgroundColour?: string }>`
	padding-bottom: ${props => (props.$inPreview ? 0 : 30)}px;
	overflow: visible;
	background-color: ${props => props.$backgroundColour ?? 'white'};
	${props =>
		!props.$inPreview &&
		`border: 1px solid #b2b2b2;
    margin: 10px;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid ${props.theme.colors.grey[400]};
    `};
`;
